<template>
  <ActListBox
    from="babe"
    :api="postActivityHots"
    :title="$t('add.predict')"
    :params="params" />
</template>
<script>
import { postActivityHots } from '@/api/babe'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'BabeActList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postActivityHots,
      params: null
    }
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/views/babe/actlist.vue